import type { ColorAttribute } from '../helpers';
import type { AttributeReplacement, StoreOption, VariantMappingRepairStrategy } from './types';

export const replacementKey = (optionID: string, valueID: string) => JSON.stringify([optionID, valueID]);

export const getReplacementAttribute = (
    attribute: ColorAttribute,
    replacement: AttributeReplacement,
    options: readonly StoreOption[]
): ColorAttribute | null => {
    const matches = options.filter((option) => option.optionID === replacement.targetOptionID);
    if (matches.length !== 1) return null;
    const values = matches[0].values.filter((value) => value.valueID === replacement.targetValueID);
    if (values.length !== 1) return null;
    return {
        ...attribute,
        Id: matches[0].optionID,
        Label: matches[0].label,
        Value: { ...attribute.Value, Id: values[0].valueID, Label: values[0].label }
    };
};

/** A merchant's choice applies to the same original option/value throughout one channel. */
export const selectedMappingsStrategy = (replacements: readonly AttributeReplacement[]): VariantMappingRepairStrategy => ({
    id: 'manual-selection',
    isApplicable: () => replacements.length > 0,
    repair: (attributes, { options }) => {
        const repaired = attributes.map((attribute) => {
            const matches = replacements.filter((replacement) => replacement.optionID === attribute.Id && replacement.valueID === attribute.Value.Id);
            if (!matches.length) return attribute;
            return matches.length === 1 ? getReplacementAttribute(attribute, matches[0], options) : null;
        });
        return repaired.every((attribute) => attribute !== null) ? repaired : null;
    }
});
